import { GlobalRole, AccessRole } from '@thehubz/shared/user-access';

export type Target = 'blank';

export interface NavigationItem {
  key: string;
  icon: string;
  svgIcon: boolean;
  text: string;
  tooltip: string;
  class?: string;
  backButton?: boolean;
  backURL?: string;
  routerLink: string;
  target?: Target;
  visible?: boolean;
  globalRole?: GlobalRole;
  accessRole?: AccessRole;
  items?: NavigationItem[];
  isCurrent?: boolean;
  testId?: string;
}

export interface NavigationEntry {
  text: string;
  menuId: number;
  visible?: boolean;
  globalRole?: GlobalRole;
  items: NavigationItem[];
  testId?: string;
}

export interface NavigationViewEntry extends NavigationEntry {
  isExpanded?: boolean;
  hasCurrent?: boolean;
}
